window.culligan = window.culligan || {}

/**
 * Setup a Gravity Forms "Date" field (datepicker) to populate a Gravity Forms 
 * "Drop Down" field (<select>) of selectable times based on the date that is selected. 
 * This requires that the Date field have the CSS class ".form-date-input", 
 * and the Drop Down field for the times to have the CSS class ".form-time-input".
 * 
 * jQuery is required to make this all work (ugh), since Gravity Forms attaches 
 * jQuery event listeners on the datepicker input, and since it fires the 
 * `gform_post_render` jQuery hook when it reloads the forms after validation.
 * 
 * @param  Number  formId  The Gravity Forms' form id.
 * @param  Object  appointmentSchedulingConfig  Used to override the default config. See config.js in the theme root.
 * @return void
 */
window.culligan.setupGravityFormsDateAndTimeFieldsForScheduling = function(formId, appointmentSchedulingConfig) {

  // The time picker (<select> input).
  const timeInput = document.querySelector('#gform_' + formId + ' .form-time-input select')
  if (! timeInput) {
    return
  }

  // Merge the provided config with the default.
  let config = window.culligan.forms.config
  config.appointmentScheduling = {...config.appointmentScheduling, ...appointmentSchedulingConfig}

  // Collect all the times from the <select> input into an array.
  let times = []

  for (let i = 0; i < timeInput.options.length; i++) {
    if (timeInput.options[i].value) {
      times.push(timeInput.options[i].value)
    }
  }

  // Clear the current times (<options>) from the <select> input, 
  // since we'll be repopulating it once a date is selected.
  timeInput.innerHTML = '<option value="" disabled selected>Time</option>'

  // The days to disable.
  let daysDisabled = []

  // Next day cutoff?
  // If the current time is on or after the `nextDayCutoffTime`, disable the following day.
  if (nextDayCutoffTimeIsApplicable(config)) {
    let tomorrow = new Date()
    tomorrow.setDate(tomorrow.getDate() + 1)
    tomorrow.setHours(0,0,0,0)
    daysDisabled.push(tomorrow.getTime())
  }

  // Friday cutoff?
  // If Friday cutoff is applicable, we'll disable today Friday through Sunday.
  if (fridayCutoffIsApplicable(config)) {
    const now = new Date()
    const currentDay = now.getDay()

    let friday, saturday, sunday = []

    // Today is Friday
    if (currentDay == 5) {
      friday = new Date()
      friday.setHours(0,0,0,0)

      saturday = new Date()
      saturday.setDate(saturday.getDate() + 1)
      saturday.setHours(0,0,0,0)

      sunday = new Date()
      sunday.setDate(sunday.getDate() + 2)
      sunday.setHours(0,0,0,0)

      daysDisabled.push(...[friday.getTime(), saturday.getTime(), sunday.getTime()])

    // Today is Saturday
    } else if (currentDay == 6) {
      saturday = new Date()
      saturday.setHours(0,0,0,0)

      sunday = new Date()
      sunday.setDate(sunday.getDate() + 1)
      sunday.setHours(0,0,0,0)

      daysDisabled.push(...[saturday.getTime(), sunday.getTime()])

    // Today is Sunday
    } else if (currentDay == 0) {
      sunday = new Date()
      sunday.setHours(0,0,0,0)

      daysDisabled.push(...[sunday.getTime()])
    }
  }

  // Disable days.
  if (daysDisabled.length > 0) {
    gform.addFilter('gform_datepicker_options_pre_init', (optionsObj, formId, fieldId) => {
      optionsObj.beforeShowDay = function(date) {
        if (jQuery.inArray(date.getTime(), daysDisabled) > -1) {
          return [false, '']
        }
        return [true, '']
      }

      return optionsObj
    })
  }

  // Why jQuery? See the function description above.
  jQuery(function() {

    // Make the date <input> readonly to force users to use the datepicker so that 
    // they can't just type in any date they want.
    jQuery('.form-date-input input.datepicker').prop('readonly', true)

    // Listen for the date selection change.
    jQuery('#gform_wrapper_' + formId).on('change', '.form-date-input input.datepicker, .form-date-input input.has-inline-datepicker', function() {
      setTimeOptions(formId, times, config)
    })
  })

  // Listen for the Gravity Forms' `gform_post_render` event/hook.
  // @see https://docs.gravityforms.com/gform_post_render/
  jQuery(document).on('gform_post_render', function(event, form_id, currentPage) {

    // Only worry about the current form.
    if (form_id == formId) {

      // Populate the time <option>s on form reload.
      setTimeOptions(formId, times, config)
    }
  })

  /**
   * Set the time <select> input's <options>s.
   * 
   * @param  Number  formId  The Gravity Forms' form id.
   * @param  Array   times   All possible selectable times.
   * @param  Object  config  Used to override the default config. See config.js in the theme root.
   * @return void
   */
  function setTimeOptions(formId, times, config) {
    const now = new Date()
    const currentDate = (now.getMonth() + 1) + '/' + now.getDate() + '/' + now.getFullYear()
    const dateInput = document.querySelector('#gform_' + formId + ' .form-date-input input')
    const timeInput = document.querySelector('#gform_' + formId + ' .form-time-input select')
    const selectedDate = dateInput.value
    let filteredTimes = []

    if (selectedDate) {

      // Filter the times if the current date was selected...
      if (selectedDate && Date.parse(selectedDate) == Date.parse(currentDate)) {
        filteredTimes = times.filter(function(time) {
          if (time) {
            time = convertAmPmTimeToHoursMinutes(time)
            return Date.parse('04/14/1981 ' + time) > Date.parse('04/14/1981 ' + (now.getHours() + config.appointmentScheduling.sameDayBuffer) + ':' + now.getMinutes())
          }
        })

      // ...otherwise use all the available times.
      } else {
        filteredTimes = times
      }

      // Filter out times within the blackout window.
      if (config.appointmentScheduling.hoursBuffer) {

        // First check if the `selectedDate` is within the blackout window.
        // For example, if `config.appointmentScheduling.hoursBuffer` is set to 24, then
        // we should filter out any times less than 24 hours from the current time if the
        // `selected` date is within 24 hours from the current time.
        let endOfBlackoutWindow = new Date()
        let hours = endOfBlackoutWindow.getHours()
        endOfBlackoutWindow.setHours(hours + config.appointmentScheduling.hoursBuffer)

        if (selectedDate && Date.parse(selectedDate) < Date.parse(endOfBlackoutWindow)) {
          filteredTimes = filteredTimes.filter(function(time) {
            if (time) {
              time = convertAmPmTimeToHoursMinutes(time)

              // Determine if the selected datetime is after the blackout window.
              return Date.parse(selectedDate + ' ' + time) > 
                Date.parse((endOfBlackoutWindow.getMonth() + 1) + '/' + endOfBlackoutWindow.getDate() + '/' + endOfBlackoutWindow.getFullYear() + ' ' + endOfBlackoutWindow.getHours() + ':' + endOfBlackoutWindow.getMinutes() + ':00')
            }
          })
        }
      }

      // Friday cutoff.
      if (
        fridayCutoffIsApplicable(config) &&
        selectedDateIsFridayCutoffApplicable(selectedDate, config)
      ) {
        const selectedDateObj = new Date(selectedDate)

        // Filter out all times before the `config.appointmentScheduling.fridayCutoffEarliestMondayTime` time.
        filteredTimes = filteredTimes.filter(function(time) {
          time = convertAmPmTimeToHoursMinutes(time)

          return Date.parse(selectedDate + ' ' + time) >= 
            Date.parse((selectedDateObj.getMonth() + 1) + '/' + selectedDateObj.getDate() + '/' + selectedDateObj.getFullYear() + ' ' + config.appointmentScheduling.fridayCutoffEarliestMondayTime + ':00')
        })
      }

      // Earliest Next Day Cutoff?
      // After this time on the current day, the earliest time that an appointment 
      // can be scheduled on the following day is the `earliestNextDayTime`.
      if (
        earliestNextDayCutoffTimeIsApplicable(config) &&
        selectedDateIsTomorrow(selectedDate)
      ) {
        const selectedDateObj = new Date(selectedDate)

        // Filter out all times before the `config.appointmentScheduling.earliestNextDayTime` time.
        filteredTimes = filteredTimes.filter(function(time) {
          time = convertAmPmTimeToHoursMinutes(time)

          return Date.parse(selectedDate + ' ' + time) >= 
            Date.parse((selectedDateObj.getMonth() + 1) + '/' + selectedDateObj.getDate() + '/' + selectedDateObj.getFullYear() + ' ' + config.appointmentScheduling.earliestNextDayTime + ':00')
        })
      }

    }

    // Add the filtered times to the <select> input as <option>s.
    timeInput.innerHTML = ''

    // If the default time selection is set to "none", then add 
    // an empty <option> to the top of the list.
    if (config.appointmentScheduling.defaultTimeSelection == 'none') {
      timeInput.innerHTML += '<option value="">Time</option>'
    }

    if (filteredTimes.length) {
      let time, hour, minutes, ampm, selected

      for (let i = 0; i < filteredTimes.length; i++) {
        if (filteredTimes[i]) {
          time = filteredTimes[i].split(':')
          hour = parseInt(time[0])
          minutes = time[1].substr(0, time[1].length - 2)
          ampm = time[1].substr(-2)

          // Default selected time.
          switch (config.appointmentScheduling.defaultTimeSelection) {
            case 'none':
              break

            case 'first':
              selected = (i == 0)
              break

            case 'last':
            default:
              selected = (i == filteredTimes.length - 1)
              break
          }

          if (hour > 12) {
            hour -= 12
          }

          timeInput.innerHTML += '<option value="' + filteredTimes[i] + '"' + (selected ? ' selected' : '') + '>' + hour + ':' + minutes + ampm + '</option>'
        }
      }
    }
  }

  /**
   * Convert a time from 3:30pm format to 15:30 format.
   * 
   * @param  String  time
   * @return String
   */
  function convertAmPmTimeToHoursMinutes(time) {
    const parts = time.split(':')
    let hours = parseInt(parts[0])
    const minutes = parts[1].substr(0, parts[1].length - 2)
    const ampm = parts[1].substr(-2)

    if (ampm == 'pm' && hours < 12) {
      hours += 12
    }

    return hours + ':' + minutes
  }

  /**
   * Determine if the next day cutoff is applicable.
   */
  function nextDayCutoffTimeIsApplicable(config) {
    if (! config.appointmentScheduling.nextDayCutoffTime) {
      return false
    }

    // Current time
    const now = new Date()
    const currentHours = now.getHours()
    const currentMinutes = now.getMinutes()

    // Cutoff time
    const cutoffParts = config.appointmentScheduling.nextDayCutoffTime.split(':')
    const cutoffHours = parseInt(cutoffParts[0])
    const cutoffMinutes = parseInt(cutoffParts[1])

    if (
      currentHours > cutoffHours || (
        currentHours == cutoffHours &&
        currentMinutes >= cutoffMinutes
      )
    ) {
      console.log('Next day cutoff is applicable')
      return true
    }

    return false
  }

  /**
   * Determine if the earliest next day cutoff is applicable.
   */
  function earliestNextDayCutoffTimeIsApplicable(config) {
    if (
      ! config.appointmentScheduling.earliestNextDayCutoffTime ||
      ! config.appointmentScheduling.earliestNextDayTime
    ) {
      return false
    }

    // Current time
    const now = new Date()
    const currentHours = now.getHours()
    const currentMinutes = now.getMinutes()

    // Cutoff time
    const cutoffParts = config.appointmentScheduling.earliestNextDayCutoffTime.split(':')
    const cutoffHours = parseInt(cutoffParts[0])
    const cutoffMinutes = parseInt(cutoffParts[1])

    if (
      currentHours > cutoffHours || (
        currentHours == cutoffHours &&
        currentMinutes >= cutoffMinutes
      )
    ) {
      console.log('Earliest next day cutoff is applicable')
      return true
    }

    return false
  }

  /**
   * Determine if the selected date is tomorrow.
   * 
   * @param  String  selectedDate
   * @return Boolean
   */
  function selectedDateIsTomorrow(selectedDate) {
    const selectedDateObj = new Date(selectedDate)
    const tomorrow = new Date()
    tomorrow.setDate(tomorrow.getDate() + 1)

    if (
      selectedDateObj.getDay() == tomorrow.getDay() &&
      selectedDateObj.getMonth() == tomorrow.getMonth() &&
      selectedDateObj.getFullYear() == tomorrow.getFullYear()
    ) {
      console.log('Selected date is tomorrow')
      return true
    }

    console.log('Selected date is not tomorrow')
    return false
  }

  /**
   * Determine if the Friday cutoff is applicable, which is if 
   * the Friday cutoff config has been set and either:
   * 
   * a. the current day of the week is Friday and the current time is after the cutoff;
   * b. or the current day of the week is Saturday or Sunday.
   * 
   * @param  Object  config
   * @return Boolean
   */
  function fridayCutoffIsApplicable(config) {
    const now = new Date()
    const currentHours = now.getHours()
    const currentMinutes = now.getMinutes()
    const currentDay = now.getDay()

    if (
      [5, 6, 0].includes(currentDay) && // Current day is a Friday, Saturday, or Sunday.
      config.appointmentScheduling.fridayCutoffTime &&
      config.appointmentScheduling.fridayCutoffEarliestMondayTime
    ) {

      const [fridayCutoffTimeHours, fridayCutoffTimeMinutes] = config.appointmentScheduling.fridayCutoffTime.split(':')

      // Saturday or Sunday
      if ([6, 0].includes(currentDay)) {
        console.log('Friday cutoff is applicable')
        return true

      // Friday
      } else {
        if (
          (currentHours > fridayCutoffTimeHours) ||
          (currentHours == fridayCutoffTimeHours && currentMinutes >= fridayCutoffTimeMinutes)
        ) {
          console.log('Friday cutoff is applicable')
          return true
        }
      }
    }

    return false
  }

  /**
   * Determine if the Friday cutoff is applicable for the selected date,
   * which is when the selected date is next Monday.
   * 
   * @param  String  selectedDate
   * @param  Object  config
   * @return Boolean
   */
  function selectedDateIsFridayCutoffApplicable(selectedDate, config) {
    const selectedDateObj = new Date(selectedDate)
    const nextMonday = new Date()
    nextMonday.setDate(nextMonday.getDate() + (((1 + 7 - nextMonday.getDay()) % 7) || 7))

    if (
      selectedDateObj.getDay() == 1 && // Sanity-check that the selected date is a Monday.
      selectedDateObj.getMonth() == nextMonday.getMonth() &&
      selectedDateObj.getDate() == nextMonday.getDate() &&
      selectedDateObj.getFullYear() == nextMonday.getFullYear()
    ) {
      console.log('Selected date is Friday cutoff applicable')
      return true
    }

    console.log('Selected date is not Friday cutoff applicable')
    return false
  }
}
